import React from 'react';
import image from "../../assets/Gemeinsamkeiten.jpg"
import {DelayedFrame} from "../DelayedFrame";
import {StimulusResponseFrame} from "../StimulusResponseFrame";
import {ResponseInput} from "../../MicroComponents/ResponseInput";
import {Form} from "../../Forms/Form";
import {MyTextArea} from "../../Forms/MyTextArea";
import {InstructionFrame} from "./InstructionFrame";

export function FolieGemeinsamkeiten(props) {
  return <DelayedFrame
    key={'similarity'}
    id={'similarity'}
    finish={props.finish}
    delay={60000}
  >
    <img src={image} alt={'Gemeinsamkeiten beachten.'} style={{width: "110%"}}/>

  </DelayedFrame>
}

